import { getLocalDate } from "../utils/utils";

export const automaticDataFields = [
  {
    title: {
      en: "CAF Status",
      hi: "CAF की स्थिति",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: {
          en: "Entity Name",
          hi: "संस्था का नाम",
        },
        htmlFor: "entity_name",
        inputProps: {
          id: "entity_name",
          name: "entity_name",
          type: "text",
          placeholder: {
            en: "Enter entity name",
            hi: "संस्था का नाम लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: {
          en: "Application Date",
          hi: "आवेदन की तारीख",
        },
        htmlFor: "application_date",
        inputProps: {
          id: "application_date",
          name: "application_date",
          type: "date",
          placeholder: {
            en: "Select application date",
            hi: "आवेदन की तारीख चुनें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: {
          en: "Approved Date",
          hi: "स्वीकृति की तारीख",
        },
        htmlFor: "updated_date",
        inputProps: {
          id: "updated_date",
          name: "updated_date",
          type: "date",
          placeholder: {
            en: "Select approved date",
            hi: "स्वीकृति की तारीख चुनें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/2 px-2 mb-4",
        label: {
          en: "CAF Status",
          hi: "CAF स्थिति",
        },
        htmlFor: "caf_status",
        inputProps: {
          id: "caf_status",
          name: "caf_status",
          type: "text",
          placeholder: {
            en: "CAF status",
            hi: "CAF की स्थिति",
          },
          disabled: true,
        },
      },
    ],
  },
  {
    title: {
      en: "Unit Details",
      hi: "यूनिट की जानकारी",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Application Name",
          hi: "आवेदक का नाम",
        },
        htmlFor: "application_name",
        inputProps: {
          id: "application_name",
          name: "application_name",
          type: "text",
          placeholder: {
            en: "Enter applicant name",
            hi: "आवेदक का नाम लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Mobile Number",
          hi: "मोबाइल नंबर",
        },
        htmlFor: "mobile_number",
        inputProps: {
          id: "mobile_number",
          name: "mobile_number",
          type: "text",
          placeholder: {
            en: "Enter mobile number",
            hi: "मोबाइल नंबर लिखें",
          },
          disabled: true,
          maxLength: 10,
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "District Name",
          hi: "जिले का नाम",
        },
        htmlFor: "district_name",
        inputProps: {
          id: "district_name",
          name: "district_name",
          type: "text",
          placeholder: {
            en: "Enter district name",
            hi: "जिले का नाम लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unit Name",
          hi: "यूनिट का नाम",
        },
        htmlFor: "unit_name",
        inputProps: {
          id: "unit_name",
          name: "unit_name",
          type: "text",
          placeholder: {
            en: "Enter unit name",
            hi: "यूनिट का नाम लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unit Address",
          hi: "यूनिट का पता",
        },
        htmlFor: "unit_address",
        inputProps: {
          id: "unit_address",
          name: "unit_address",
          type: "text",
          placeholder: {
            en: "Enter unit address",
            hi: "यूनिट का पता लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "NIC Code",
          hi: "NIC कोड",
        },
        htmlFor: "nic_code",
        inputProps: {
          id: "nic_code",
          name: "nic_code",
          type: "text",
          placeholder: {
            en: "Enter NIC code",
            hi: "NIC कोड लिखें",
          },
          disabled: true,
        },
      },
      {
        divClass: "w-full lg:w-1/2 px-2 mb-4",
        label: {
          en: "Unit Description",
          hi: "यूनिट का विवरण",
        },
        htmlFor: "unit_description",
        inputProps: {
          id: "unit_description",
          name: "unit_description",
          type: "text",
          placeholder: {
            en: "Enter unit details",
            hi: "यूनिट की जानकारी लिखें",
          },
          disabled: true,
        },
      },
    ],
  },
];

export const manualaDataFields = [
  {
    title: {
      en: "Investment Details",
      hi: "निवेश की जानकारी",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Investment In Land",
          hi: "जमीन में निवेश",
        },
        htmlFor: "investment_in_land",
        inputProps: {
          id: "investment_in_land",
          name: "investment_in_land",
          type: "text",
          placeholder: {
            en: "Amount (Cr)",
            hi: "राशि लिखें (करोड़ में)",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
            message: {
              en: "Please enter a valid amount.(can be 0 or more up to 3 decimal places)",
              hi: "कृपया सही राशि दर्ज करें (यह 0 या इससे अधिक हो सकती है, और अधिकतम 3 दशमलव स्थान तक हो सकती है)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Investment In Building",
          hi: "भवन में निवेश",
        },
        htmlFor: "investment_in_building",
        inputProps: {
          id: "investment_in_building",
          name: "investment_in_building",
          type: "text",
          placeholder: {
            en: "Amount (Cr)",
            hi: "राशि लिखें (करोड़ में)",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^(?!0(\.0{1,3})?$)(\d+)(\.\d{1,3})?$/,
            message: {
              en: "Please enter a valid amount.(must be greater than zero and up to 3 decimal places)",
              hi: "राशि शून्य से अधिक होनी चाहिए (अधिकतम 3 दशमलव स्थान तक).",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Investment In (P. & Eq.)",
          hi: "मशीन और उपकरण में निवेश",
        },
        htmlFor: "investment_in_peq",
        inputProps: {
          id: "investment_in_peq",
          name: "investment_in_peq",
          type: "text",
          placeholder: {
            en: "Amount (Cr)",
            hi: "राशि लिखें (करोड़ में)",
          },
          disabled: false,
          validation: {
            required: false,
            pattern: /^(?!0(\.0{1,3})?$)(\d+)(\.\d{1,3})?$/,
            message: {
              en: "Please enter a valid amount.(must be greater than zero and up to 3 decimal places)",
              hi: "कृपया सही राशि दर्ज करें (यह 0 या इससे अधिक हो सकती है, और अधिकतम 3 दशमलव स्थान तक हो सकती है)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Investment In Other",
          hi: "अन्य निवेश",
        },
        htmlFor: "investment_in_other",
        inputProps: {
          id: "investment_in_other",
          name: "investment_in_other",
          type: "text",
          placeholder: {
            en: "Amount (Cr)",
            hi: "राशि लिखें (करोड़ में)",
          },
          disabled: false,
          validation: {
            required: false,
            pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
            message: {
              en: "Enter a valid amount (can be 0 or more).",
              hi: "एक मान्य राशि दर्ज करें (यह 0 या इससे अधिक हो सकती है)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Investment",
          hi: "कुल निवेश",
        },
        htmlFor: "total_investment",
        inputProps: {
          id: "total_investment",
          name: "total_investment",
          type: "text",
          placeholder: {
            en: "Total Amount (Cr)",
            hi: "कुल राशि (करोड़ में)",
          },
          disabled: true,
          validation: {
            required: true,
            message: {
              en: "Total investment will be auto calculated.",
              hi: "कुल निवेश अपने आप दिखेगा।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Employment",
          hi: "रोजगार",
        },
        htmlFor: "employment",
        inputProps: {
          id: "employment",
          name: "employment",
          type: "number",
          placeholder: {
            en: "Employment",
            hi: "रोज़गार",
          },
          disabled: false,
          validation: {
            required: true,
            min: 0,
            pattern: /^[0-9]+$/,
            message: {
              en: "Please enter number of employees.",
              hi: "कर्मचारियों की संख्या दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 px-2 mb-4",
        label: {
          en: "Project Details",
          hi: "परियोजना की जानकारी",
        },
        htmlFor: "project_details",
        inputProps: {
          id: "project_details",
          name: "project_details",
          type: "text",
          placeholder: {
            en: "Rooms / Services details",
            hi: "कमरे या सेवाओं की जानकारी लिखें",
          },
          disabled: false,
          validation: {
            minLength: 3,
            message: {
              en: "Please enter project details.",
              hi: "परियोजना की जानकारी दर्ज करें।",
            },
          },
        },
      },
    ],
  },
  {
    title: {
      en: "Investor Details",
      hi: "निवेशक की जानकारी",
    },
    fields: [
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Name",
          hi: "नाम",
        },
        htmlFor: "name",
        inputProps: {
          id: "name",
          name: "name",
          type: "text",
          placeholder: {
            en: "Name",
            hi: "नाम लिखें",
          },
          disabled: false,
          validation: {
            required: true,
            minLength: 3,
            message: {
              en: "Enter investor name.",
              hi: "निवेशक का नाम दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Designation",
          hi: "पद",
        },
        htmlFor: "designation",
        inputProps: {
          id: "designation",
          name: "designation",
          type: "text",
          placeholder: {
            en: "Designation",
            hi: "पद लिखें",
          },
          disabled: false,
          validation: {
            required: true,
            min: 1,
            message: {
              en: "Enter designation",
              hi: "पद दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Gender",
          hi: "लिंग",
        },
        htmlFor: "gender",
        inputProps: {
          id: "gender",
          name: "gender",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Male", value: "Male", hi: "पुरुष" },
            { label: "Female", value: "Female", hi: "महिला" },
            { label: "Other", value: "Other", hi: "अन्य" },
          ],
          validation: {
            required: true,
            message: {
              en: "Select gender.",
              hi: "कृपया लिंग चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Share Holding",
          hi: "हिस्सेदारी (%)",
        },
        htmlFor: "share_holding",
        inputProps: {
          id: "share_holding",
          name: "share_holding",
          type: "text",
          placeholder: {
            en: "Share %",
            hi: "हिस्सेदारी प्रतिशत लिखें",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid percentage (0-100).",
              hi: "मान्य प्रतिशत दर्ज करें (0 से 100)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Mobile Number",
          hi: "मोबाइल नंबर",
        },
        htmlFor: "mobile_number",
        inputProps: {
          id: "mobile_number",
          name: "mobile_number",
          type: "text",
          placeholder: {
            en: "Mobile Number",
            hi: "मोबाइल नंबर लिखें",
          },
          disabled: false,
          maxLength: 10,
          validation: {
            required: true,
            pattern: /^[6-9]\d{9}$/,
            message: {
              en: "Enter a valid 10-digit mobile number.",
              hi: "मान्य 10 अंकों का मोबाइल नंबर दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "PAN Number",
          hi: "पैन नंबर",
        },
        htmlFor: "pan_number",
        inputProps: {
          id: "pan_number",
          name: "pan_number",
          type: "text",
          placeholder: {
            en: "PAN Number",
            hi: "पैन नंबर लिखें",
          },
          disabled: false,
          maxLength: 10,
          validation: {
            required: true,
            pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            message: {
              en: "Enter a valid PAN number (e.g. ABCDE1234F).",
              hi: "मान्य पैन नंबर दर्ज करें (जैसे ABCDE1234F)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-[14.28%] md:w-1/2 px-2 mb-4",
        label: {
          en: "Uttarakhandi Resident",
          hi: "उत्तराखंड का निवासी",
        },
        htmlFor: "uttarakhandi_resident",
        inputProps: {
          id: "uttarakhandi_resident",
          name: "uttarakhandi_resident",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: true,
            message: {
              en: "Select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
    ],
  }
];

export const manuala5ADataFields = [
  {
    title: {
      en: "Project Status",
      hi: "परियोजना की स्थिति",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land Available",
          hi: "जमीन उपलब्ध है",
        },
        htmlFor: "land_available",
        inputProps: {
          id: "land_available",
          name: "land_available",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Section 143 (Approval)",
          hi: "धारा 143 की स्वीकृति",
        },
        htmlFor: "section_143_approval",
        inputProps: {
          id: "section_143_approval",
          name: "section_143_approval",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Consent to Establishment by Pollution Control Board",
          hi: "प्रदूषण नियंत्रण बोर्ड से स्थापना की अनुमति",
        },
        htmlFor: "cte_pcb",
        inputProps: {
          id: "cte_pcb",
          name: "cte_pcb",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Building Plan Approval",
          hi: "भवन योजना की स्वीकृति",
        },
        htmlFor: "building_plan_approval",
        inputProps: {
          id: "building_plan_approval",
          name: "building_plan_approval",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Construction Status",
          hi: "निर्माण की स्थिति",
        },
        htmlFor: "construction_status",
        inputProps: {
          id: "construction_status",
          name: "construction_status",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Completed", value: "Completed", hi: "पूरा हो चुका है" },
            {
              label: "Under Construction",
              value: "Under Construction",
              hi: "निर्माण चल रहा है",
            },
            {
              label: "Construction not started",
              value: "Construction not started",
              hi: "निर्माण शुरू नहीं हुआ",
            },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select construction status.",
              hi: "कृपया निर्माण की स्थिति चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Start Date of Construction",
          hi: "निर्माण शुरू होने की तारीख",
        },
        htmlFor: "start_date_of_construction",
        inputProps: {
          id: "start_date_of_construction",
          name: "start_date_of_construction",
          type: "date",
          placeholder: {
            en: "Select start date",
            hi: "निर्माण शुरू होने की तारीख चुनें",
          },
          disabled: false,
          max: getLocalDate(),
          validation: {
            required: true,
            message: {
              en: "Start date is required.",
              hi: "निर्माण शुरू होने की तारीख दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Expected Date of Completion",
          hi: "निर्माण पूरा होने की अनुमानित तारीख",
        },
        htmlFor: "expected_date_of_completion",
        inputProps: {
          id: "expected_date_of_completion",
          name: "expected_date_of_completion",
          type: "date",
          placeholder: {
            en: "Select expected completion date",
            hi: "निर्माण पूरा होने की अनुमानित तारीख चुनें",
          },
          disabled: false,
          min: getLocalDate(),
          validation: {
            required: true,
            message: {
              en: "Expected completion date is required.",
              hi: "अनुमानित तारीख दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Completion Date of Construction",
          hi: "निर्माण पूरा होने की तारीख",
        },
        htmlFor: "completion_date_of_construction",
        inputProps: {
          id: "completion_date_of_construction",
          name: "completion_date_of_construction",
          type: "date",
          placeholder: {
            en: "Select completion date",
            hi: "निर्माण पूरा होने की तारीख चुनें",
          },
          disabled: false,
          max: getLocalDate(),
          validation: {
            required: true,
            message: {
              en: "Completion date is required.",
              hi: "निर्माण पूरा होने की तारीख दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Available Incentive Scheme",
          hi: "उपलब्ध प्रोत्साहन योजना",
        },
        htmlFor: "available_incentive_scheme",
        inputProps: {
          id: "available_incentive_scheme",
          name: "available_incentive_scheme",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "योजना चुनें",
          },
          disabled: false,
          options: [
            {
              label: "Uttarakhand Paryatan Udhyami Protsahan Yojana",
              hi: "उत्तराखंड पर्यटन उद्यमी प्रोत्साहन योजना",
              value: "prayatanuddamiprotsahanyojna",
            },
            {
              label: "Uttarakhand Tourism Policy 2023",
              hi: "उत्तराखंड पर्यटन नीति 2023",
              value: "uttarakhandtourismpolicy2023",
            },
          ],
          validation: {
            required: true,
            message: {
              en: "Please select an incentive scheme.",
              hi: "कृपया प्रोत्साहन योजना चुनें।",
            },
          },
        },
      },
    ],
  },
  {
    title: {
      en: "Unit Operational Details",
      hi: "इकाई संचालन की जानकारी",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Consent to Operate by Pollution Control Board",
          hi: "प्रदूषण नियंत्रण बोर्ड से संचालन की अनुमति",
        },
        htmlFor: "cto_pcb",
        inputProps: {
          id: "cto_pcb",
          name: "cto_pcb",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: false,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "NOC (Fire)",
          hi: "अग्निशमन एनओसी",
        },
        htmlFor: "noc_fire",
        inputProps: {
          id: "noc_fire",
          name: "noc_fire",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: false,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Travel Trade Registration",
          hi: "ट्रैवल ट्रेड पंजीकरण",
        },
        htmlFor: "travel_trade_registration",
        inputProps: {
          id: "travel_trade_registration",
          name: "travel_trade_registration",
          type: "select",
          placeholder: {
            en: "Select Option",
            hi: "विकल्प चुनें",
          },
          disabled: false,
          options: [
            { label: "Yes", value: "Yes", hi: "हाँ" },
            { label: "No", value: "No", hi: "नहीं" },
          ],
          validation: {
            required: false,
            message: {
              en: "Please select Yes or No.",
              hi: "कृपया हाँ या नहीं चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 px-2 mb-4",
        label: {
          en: "Commercial Operation Date",
          hi: "व्यावसायिक संचालन की तारीख",
        },
        htmlFor: "commercial_operation_date",
        inputProps: {
          id: "commercial_operation_date",
          name: "commercial_operation_date",
          type: "date",
          placeholder: {
            en: "Select operation date",
            hi: "संचालन की तारीख चुनें",
          },
          disabled: false,
          max: getLocalDate(),
          validation: {
            required: false,
            message: {
              en: "Please select operation date.",
              hi: "संचालन की तारीख चुनें।",
            },
          },
        },
      },
    ],
  },
];

export const manualDataFieldSections = [
  {
    title: {
      en: "Investment Information",
      hi: "निवेश की जानकारी",
    },
    data: manualaDataFields,
  },
  {
    title: {
      en: "Project Information",
      hi: "परियोजना की जानकारी",
    },
    data: manuala5ADataFields,
  },
];


